import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";

function Stars({ rating }) {
  return (
    <div className="flex gap-0.5" aria-label={`${rating} étoiles sur 5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={16}
          className={i <= rating ? "fill-[#C86641] text-[#C86641]" : "text-[#E5E3DD]"}
          strokeWidth={1.5}
        />
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/testimonials")
      .then((r) => setItems(r.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading || items.length === 0) return null;

  return (
    <section
      id="avis"
      data-testid="testimonials-section"
      className="py-24 md:py-32 border-b border-[#E5E3DD] bg-[#FAFAFA]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#C86641]">
              05 — Avis clients
            </div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-4xl md:text-6xl tracking-tighter leading-[0.95]">
              Ils ont fait confiance à E-PRO.
            </h2>
            <p className="mt-6 text-[#5C5A56] max-w-2xl">
              La satisfaction de mes clients est ma plus belle vitrine.
              Voici quelques retours de chantiers récents.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t) => (
            <article
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              className="bg-[#F3F1ED] border border-[#E5E3DD] p-7 flex flex-col gap-5"
            >
              <Stars rating={t.rating} />
              <p className="text-[#1A1918] leading-relaxed text-[15px] flex-1">
                « {t.comment} »
              </p>
              <div className="pt-4 border-t border-[#E5E3DD]">
                <div className="font-semibold text-[#1A1918]">{t.name}</div>
                <div className="text-xs text-[#5C5A56] mt-1">
                  {[t.project_type, t.location].filter(Boolean).join(" — ")}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
